import { useMemo } from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';


export function Card(props) {

    const navigation =  useNavigate();

    const truncateText = (text, maxLength) => {
        if (text && text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    };

    const truncatedTitle = useMemo(() => {
        return truncateText(props.title, 20);
    }, [props.title]);

    const truncatedDescription = useMemo(() => {
        return truncateText(props.description, 40);
    }, [props.description]);


    function handleNavigate() {
        navigation(`/core/tutorialscard/list/${props.id}`);
    }


    return (
        <div className="card tutorial-card-wrapper" onClick={handleNavigate}>
            <i className={props.icon ? props.icon : 'fa-solid fa-user mb-4 p-2'} />
            <div className='tutorial-card-info-wrapper'>
                <span className='tutorial-card-title' data-tip data-for={"tooltip-title-" + props.id}>
                    {truncatedTitle}
                </span>
                <ReactTooltip id={"tooltip-title-" + props.id} place="right" effect="solid">
                    {props.title}
                </ReactTooltip>
                <span className='tutorial-card-description' data-tip data-for={"tooltip-description-" + props.id}>
                    {truncatedDescription}
                </span>
                <ReactTooltip id={"tooltip-description-" + props.id} place="right" effect="solid">
                    {props.description}
                </ReactTooltip>
                <div className='tutorial-viewed-videos' onClick={() => handleNavigate()}>
                    {props.viewed_videos > 0 ? (
                        <span className='tutorial-viewed-videos-color'>
                            <i className='fa-solid fa-circle tutorial-viewed-videos-icon-size'/>
                            {`${props.viewed_videos} vídeo(s) não assistido(s)`}
                        </span>
                    ) : (
                        <span className='tutorial-viewed-videos-color-see-more'>
                            Ver mais
                            <i className='fa-solid fa-chevron-right tutorial-viewed-videos-icon-size-see-more'/>
                        </span>
                    )}                    
                </div>
            </div>
        </div>
    )
};